import { render, staticRenderFns } from "./ShowInfo.vue?vue&type=template&id=0334c548&scoped=true&"
import script from "./ShowInfo.vue?vue&type=script&lang=js&"
export * from "./ShowInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowInfo.vue?vue&type=style&index=0&id=0334c548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334c548",
  null
  
)

export default component.exports